// SPDX-License-Identifier: AGPL-3.0-or-later

import PremiumState from '@app/features/premium/state/PremiumState';
import ShopCatalog from '@app/features/shop/state/ShopCatalog';

// Micup: the account has a Plus subscription that still holds (renewing, or canceled with paid time left): no Plus is
// bought once beside it and no one-time copy shows. The premium state says so, or the catalog does before it is read.
export function holdsPlusSubscription(userId: string | undefined): boolean {
	return (
		PremiumState.holdsPaddleSubscription(userId) || ShopCatalog.recurringEligibility?.reason === 'existing_subscription'
	);
}
